import { render, staticRenderFns } from "./protect-footer.vue?vue&type=template&id=fa980168&scoped=true&"
import script from "./protect-footer.vue?vue&type=script&lang=js&"
export * from "./protect-footer.vue?vue&type=script&lang=js&"
import style0 from "./protect-footer.vue?vue&type=style&index=0&id=fa980168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa980168",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
